import { defaultAnimateLayoutChanges, type AnimateLayoutChanges } from '@dnd-kit/sortable';

// Force the FLIP animation on every reorder, not just ones caused by an active drag —
// this is what animates an area sliding to its new position when checked/unchecked.
export const animateCleaningAreaListLayoutChanges: AnimateLayoutChanges = args =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });
